import * as React from 'react';
import { BaSeTheme, BaSeDataTable, BaSeActionItem } from '@base/react';
import { DataTableWrapper } from '../produtos-styled';

const formatDate = (dateObj) => {
  const date = new Date(dateObj.dataAtualizacao);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const getTableColumns = (onEdit, onManageFiles, onDelete) => [
  {
    accessorKey: 'idPortfolio',
    header: 'Id do Produto',
    mapper: ({ values }) => values.idPortfolio ?? '',
  },
  {
    accessorKey: 'nome',
    header: 'Nome do produto',
  },
  {
    accessorKey: 'tipoProduto.nome',
    header: 'Tipo do produto',
  },
  {
    accessorKey: 'ativo',
    header: 'Status',
    mapper: ({ values }) => (values.ativo ? 'Ativo' : 'Inativo'),
  },
  {
    accessorKey: 'dataAtualizacao',
    header: 'Data de atualização',
    mapper: ({ values }) => formatDate(values),
  },
  {
    header: 'Ações',
    mapper: ({ values }) => (
      <BaSeActionItem
        position="top-right"
        size="small"
        minWidth="230px"
        items={[
          {
            text: 'Editar',
            icon: 'pen',
            callback: () => onEdit(values),
          },
          {
            text: 'Gestão de arquivos',
            icon: 'folder',
            callback: () => onManageFiles(values),
          },
          {
            text: 'Remover',
            color: BaSeTheme.colors.feedbackInterface.erro35,
            icon: 'trash-alt',
            callback: () => onDelete(values),
          },
        ]}
      />
    ),
  },
];

export const ProductsTable = ({
  produtos,
  total,
  loading,
  fetchData,
  onEdit,
  onManageFiles,
  onDelete,
}) => {
  return (
    <DataTableWrapper>
      <BaSeDataTable
        backgroundColor={BaSeTheme.colors.defaultColors.white}
        config={getTableColumns(onEdit, onManageFiles, onDelete)}
        fetchData={fetchData}
        hasTextFilter
        onTextFilter={({ setFilter, term }) => {
          setFilter({ filter: term });
        }}
        hasPagination
        hasSorting
        textFilterAlwaysVisible
        initialPageIndex={0}
        initialPageSize={10}
        initialSortField="dataAtualizacao"
        initialSortType="DESC"
        isLoading={loading}
        items={produtos}
        total={total}
        columnConfig={[
          {
            columnId: 'nome',
            width: 575,
          },
        ]}
      />
    </DataTableWrapper>
  );
};
